import React from 'react'
import ProcessorModal from '.'
import AutoQuestionnaireAttachments from '../components/Attachments'

export default function AttachmentsModal({
  open = false,
  onClose = () => {},
  initialAttachments = {},
  headerLabel = 'upload'
}) {
  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div style={{ width: 380 }}>
          <div className="dome-d-flex dome-flex-column dome-gap24">
            <div className="dome-d-flex dome-align-center dome-gap12">
              <span className="dome-d-flex dome-align-center ">
                <i className="fa-light fa-paperclip fa-xl dome-color-dark-green"></i>
              </span>
              <span className="dome-h2 dome-color-dark-green">{headerLabel}</span>
            </div>
            <div className="dome-d-flex dome-flex-column dome-gap24">
              <AutoQuestionnaireAttachments initialAttachments={initialAttachments} />
            </div>
            <div className="dome-d-flex dome-justify-between dome-flex-row-reverse">
              <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-grey-stroke">
                done
              </button>
            </div>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
